import { CardActionArea, CardContent, Stack, Typography, useTheme } from "@mui/material";
import { MprcCard } from "components";
import { Formaters } from "lib/Formaters";
import React from "react";

export interface IProps {
    value: number;
    isPercent?: boolean;
    title?: React.ReactNode;
    subtitle?: React.ReactNode;
    active?: boolean;
    onClick?: () => void;
}

export const DASH_SQUARE_CARD_WIDTH = 190;
export const DASH_SQUARE_CARD_HEIGHT = 170;

export const DashSquareCardSelect: React.FC<IProps> = ({ value, isPercent, title, subtitle, active, onClick }) => {

    const theme = useTheme();

    return (
        <MprcCard sx={{ width: DASH_SQUARE_CARD_WIDTH, height: DASH_SQUARE_CARD_HEIGHT }}>
            <CardActionArea
                onClick={onClick}
                data-active={active ? '' : undefined}
                sx={{
                    height: '100%',
                    '&[data-active]': {
                        backgroundColor: theme.palette.notice.light,
                        '&:hover': {
                            backgroundColor: 'action.selectedHover',
                        },
                    },
                }}
            >
                <CardContent>
                    <Stack alignItems="center" justifyContent="center" spacing={2}>
                        <Typography variant="h1" component="div" fontSize={64} color="muted.main">
                            {Formaters.localeNumber(value)}{isPercent && "%"}
                        </Typography>
                        {title &&
                            <Stack direction="column" alignItems="center" justifyContent="center" height={40}>
                                <Typography
                                    width={140}
                                    component="div"
                                    fontSize={14}
                                    lineHeight="normal"
                                    color="muted.main"
                                    textTransform="uppercase"
                                    fontWeight="bold"
                                    align="center"
                                >
                                    {title}
                                </Typography>
                                {subtitle}
                            </Stack>
                        }
                    </Stack>
                </CardContent>
            </CardActionArea>
        </MprcCard>
    );
};
